import {
  withUser,
  UserProps,
} from "@customer-tools-web/component-authentication";
import * as React from "react";
import { LoadableComponent } from "react-loadable";
import { withRouter, RouteComponentProps } from "react-router";

import { ROUTE_URL, URL_PREFIX } from "../common/const";

type Props = UserProps & RouteComponentProps;

export default function (
  ComposedComponent:
    | (React.ComponentClass<any, any> & LoadableComponent)
    | (React.FC<any> & LoadableComponent)
) {
  const PermissionsGuard: React.FC<Props> = (props: Props) => {
    React.useEffect(() => {
      const isSpecialistReport: boolean = props?.location?.pathname?.includes(
        ROUTE_URL.reportings.specialist
      );

      if (
        isSpecialistReport &&
        !props?.user?.permissions?.report?.canViewSpecialistReport
      ) {
        props.history?.push(`${URL_PREFIX}/non-existingpage`);
      }
    }, [props.user?.permissions]);

    return <ComposedComponent {...props} />;
  };

  return withUser(withRouter(PermissionsGuard));
}
